import ReactCountryFlag from 'react-country-flag';

/** ISO 639-1 app UI locale → flag country (navbar, profile). Not used for outreach. */
const APP_UI_LANGUAGE_COUNTRY_CODES: Record<string, string> = {
  en: 'US',
  sv: 'SE',
  fr: 'FR',
  es: 'ES',
  de: 'DE',
};

const flagStyle = {
  width: 20,
  height: 15,
  display: 'inline-block',
  flexShrink: 0,
  verticalAlign: 'middle',
} as const;

export const CountryFlag = ({ countryCode }: { countryCode: string }) => (
  <ReactCountryFlag countryCode={countryCode.toUpperCase()} svg style={flagStyle} aria-hidden />
);

export const countryCodeForAppLanguage = (lang: string) =>
  APP_UI_LANGUAGE_COUNTRY_CODES[lang] ?? APP_UI_LANGUAGE_COUNTRY_CODES[lang.split('-')[0]] ?? 'US';
